import { render, staticRenderFns } from "./comp-content-v2.vue?vue&type=template&id=77d00748&"
import script from "./comp-content-v2.vue?vue&type=script&lang=ts&"
export * from "./comp-content-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports